import { render, staticRenderFns } from "./Dates.vue?vue&type=template&id=1bd22987&"
import script from "./Dates.vue?vue&type=script&lang=js&"
export * from "./Dates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports